// Datadog RUM masks session replay text by default. Use this only when the
// product/security tradeoff has been considered and the unmasked content helps
// support/debugging. Prefer the narrowest element that contains the intended UI
// text, and keep credentials, secrets, profile/account details, and other
// user-private content masked.
export const DD_PRIVACY_ALLOW = 'allow';

// Fully removes the element (and its subtree) from session replay, replacing it
// with an opaque placeholder of the same dimensions. Unlike 'mask', this also
// hides DOM attributes such as `href` and `src`, so use it whenever a sensitive
// value would otherwise be baked into an attribute the default 'mask' level
// does not scrub (e.g. Stripe hosted invoice URLs, signed download links).
export const DD_PRIVACY_HIDDEN = 'hidden';
